import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import './pagoCasco.scss'

const PagoCascoDetails = () => {
  const { t } = useTranslation()
  const checkoutInfo = useSelector(state => {
    return state.checkout.entity
  });

  const calcularDescuentoCasco = () => {
    const motor = checkoutInfo?.presupuesto?.piezas.find(p => p.tipo_pieza_id === 406);

    if(motor) {
      const precioMotor = motor.precio_venta;
      const descuento = Math.floor(precioMotor / 1000) * 50;
      return descuento;
    } else return null;
  }

  return <div className="w-100 recogida-casco">
        <h2>{t('carrito.pedido.casco.info.1')}</h2>

        <div className='w-100 mt-2'>
            <ol>
                <li>{t('carrito.pedido.casco.info.2')}</li>
                <li>{t('carrito.pedido.casco.info.3')}</li>
                <li>{t('carrito.pedido.casco.info.4')}</li>
                <li>{t('carrito.pedido.casco.info.5')}</li>
                <li>{t('carrito.pedido.casco.info.6')}</li>
                <li>{t('carrito.pedido.casco.info.7')}</li>
                <li>{t('carrito.pedido.casco.info.8', { importe_casco: calcularDescuentoCasco()})}</li>
            </ol>

            <p className='fw-bold'>{t('carrito.pedido.casco.info.9')}</p>
        </div>

        <div className='w-100 mt-4'>
          <h3>{t('carrito.pedido.casco.condiciones.title')}</h3>

          <ul>
            <li>{t('carrito.pedido.casco.condiciones.1')}</li>
            <li>{t('carrito.pedido.casco.condiciones.2')}</li>
              <ul>
                <li>{t('carrito.pedido.casco.condiciones.3')}</li>
                <li>{t('carrito.pedido.casco.condiciones.4')}</li>
                <li>{t('carrito.pedido.casco.condiciones.5')}</li>
                <li>{t('carrito.pedido.casco.condiciones.6')}</li>
              </ul>
          </ul>
        </div>
    </div>
}

export default PagoCascoDetails
